
    <div class="sub-workflow-container">
        <div class="container mt-3">
            <!-- Advanced Settings Panel -->
            <div v-if="showLandingOptions" class="settings-wrapper">

                <div class="settings-content-area">
                    <!-- Main Panel -->
                    <div class="settings-panel">
                        <!-- Settings Header -->
                        <div class="settings-header mb-4">
                            <h1 class="settings-title mb-2">Advanced Settings</h1>
                            <p class="settings-description text-muted mb-0">Configure additional workflow options to enhance your experience</p>
                        </div>

                        <!-- Settings List -->
                        <div class="settings-list">
                    <!-- Sub-Workflow Option -->
                    <div class="settings-item mb-3" @click="chooseCreateSubWorkflow">
                        <div class="settings-item-icon icon-blue">
                            <i class="fas fa-sitemap"></i>
                        </div>
                        <div class="settings-item-content flex-grow-1">
                            <div class="settings-item-header mb-2">
                                <h3 class="settings-item-title mb-1">Sub-Workflows</h3>
                                <span class="settings-item-badge">Routing</span>
                            </div>
                            <p class="settings-item-description text-muted mb-0">
                                Create workflow routers to direct users to different internal workflows or external services
                            </p>
                        </div>
                        <div class="settings-item-arrow ms-3">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                    </div>

                    <!-- Thank You Page Option -->
                    <div class="settings-item" @click="chooseSetupCustomThankYou">
                        <div class="settings-item-icon icon-green">
                            <i class="fas fa-hand-holding-heart"></i>
                        </div>
                        <div class="settings-item-content flex-grow-1">
                            <div class="settings-item-header mb-2">
                                <h3 class="settings-item-title mb-1">Thank You Page</h3>
                                <span v-if="has_thank_you_config" class="settings-item-badge badge-success">
                                    <i class="fas fa-check"></i> Configured
                                </span>
                                <span v-else class="settings-item-badge badge-new">Customizable</span>
                            </div>
                            <p class="settings-item-description text-muted mb-0">
                                Design a custom completion page with personalized messaging and branding
                            </p>
                        </div>
                        <div class="settings-item-arrow ms-3">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                    </div>
                </div>

                        <!-- Settings Footer -->
                        <div class="settings-footer mt-4 pt-4 border-top">
                            <div class="settings-footer-hint mb-3">
                                <i class="fas fa-info-circle me-2"></i>
                                <span class="text-muted">These settings are optional. You can configure them later.</span>
                            </div>
                            <button class="settings-skip-btn" @click="skipCreation">
                                Skip for now
                                <i class="fas fa-arrow-right ms-2"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <!-- SERVICE CREATION SECTION (only show after user chooses Sub-Workflows) -->
            <div v-if="!showLandingOptions && showCreateServiceForm">
                <!-- Create new service section -->
                <div class="card shadow-md rounded-3 mt-3">
                    <div class="card-body p-4">
                        <h5 class="mb-4">Create Sub-workflow Service</h5>
                        <form @submit.prevent="createService">
                            <div class="mb-4">
                                <label class="form-label fw-semibold mb-2">Sub-workflow title <span class="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    class="form-control" 
                                    v-model="serviceData.service_name"
                                    placeholder="E.g., What's Next?" 
                                    required
                                >
                                <small class="text-muted d-block mt-2">This name will be displayed to users when they navigate sub-workflows</small>
                            </div>
                            
                            <div class="d-flex justify-content-end mt-4">
                                <button type="button" class="btn btn-bg-dark text-xs rounded-small btn-sm me-2" @click="skipCreation">Skip</button>
                                <button type="submit" class="btn btn-bg-green text-xs rounded-small btn-sm" :disabled="isSubmitting">
                                    <span v-if="isSubmitting">
                                        <i class="fas fa-spinner fa-spin me-1"></i> Creating...
                                    </span>
                                    <span v-else>Create Service</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Existing services section -->
                <div class="card shadow-md rounded-3 mt-3" v-if="existingServices.length > 0">
                    <div class="card-body p-4">
                        <h5 class="mb-4">Or use an existing service</h5>
                        <div class="table-responsive">
                            <table class="table table-striped table-hover align-middle text-xs">
                                <thead class="table-light">
                                    <tr>
                                        <th class="text-xs fw-bold py-3">No.</th>
                                        <th class="text-xs fw-bold py-3">Service Name</th>
                                        <th class="text-xs fw-bold py-3">Date Created</th>
                                        <th class="text-xs fw-bold text-center py-3">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(service, index) in existingServices" :key="service.service_id">
                                        <td class="py-3">{{ index + 1 }}</td>
                                        <td class="py-3">{{ service.service_name }}</td>
                                        <td class="py-3">{{ formatDate(service.created_at) }}</td>
                                        <td class="py-3 text-center">
                                            <button class="btn btn-bg-green btn-sm rounded-small" @click="continueWithService(service)">
                                                <i class="fas fa-check-circle me-1"></i> Use this
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- WORKFLOW ROUTER SECTION (only show when not on landing and service form is hidden) -->
            <div v-if="!showLandingOptions && !showCreateServiceForm">
                <div class="card shadow-md rounded-3"> 
                    <div class="card-body p-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="customer-info">
                                <label class="d-flex align-items-center mb-0">
                                    <i class="fas fa-project-diagram text-primary fa-xl me-3"></i>
                                    <div>
                                        <span class="fw-bold d-block">{{ workflow_name }}</span>
                                        <span class="text-muted fst-italic text-xs">Workflow Router</span>
                                    </div>
                                </label>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-bg-dark text-xs rounded-small btn-sm" @click="next">
                                    Continue
                                </button>
                                <button class="btn btn-bg-green text-xs rounded-small btn-sm" @click="show_add_sub_workflow_modal">
                                    <i class="fas fa-plus me-1"></i> Add Workflow Router
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card shadow-md rounded-3 mt-3" v-if="workflows.length > 0">
                    <transition name="fade" mode="out-in">
                        <div class="card-body p-3">
                            <div class="table-responsive">
                                <table class="table table-striped table-hover align-middle text-xs">
                                    <thead class="table-light">
                                        <tr>
                                            <th class="text-xs fw-bold py-3">No.</th>
                                            <th class="text-xs fw-bold py-3">Name of Router</th>
                                            <th class="text-xs fw-bold py-3">Workflow Router Type</th>
                                            <th class="text-xs fw-bold py-3">Date Created</th>
                                            <th class="text-xs fw-bold text-center py-3">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sub_workflow, index) in paginator_sub_workflows" :key="index">
                                            <td class="py-3">{{ (current_page - 1) * items_per_page + index + 1}}</td>
                                            <td class="py-3">
                                                {{ sub_workflow.router_name }}
                                            </td>
                                            <td class="py-3">
                                                <span class="badge bg-info text-dark">{{ sub_workflow.sub_workflow_type }}</span>
                                            </td>
                                            <td class="py-3">{{ formatDate(sub_workflow.date_created)}}</td>
                                            <td class="py-3 text-center">
                                                <button class="btn btn-bg-green btn-sm rounded-small"
                                                    @click="view_sub_workflow(sub_workflow)">
                                                    <i class="fa fa-eye me-1"></i>
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Pagination -->
                            <div class="d-flex justify-content-between align-items-center mt-4 pt-3 border-top" v-if="workflows.length > 0">
                                <div class="text-xs text-muted">
                                    Showing {{ (current_page - 1) * items_per_page + 1 }} to
                                    {{ Math.min(current_page * items_per_page, workflows.length) }}
                                    of {{ workflows.length }} entries
                                </div>

                                <div class="d-flex align-items-center gap-2">
                                    <button class="btn btn-sm btn-outline-secondary" @click="previous_page"
                                        :disabled="current_page === 1">
                                        <i class="fas fa-chevron-left"></i>
                                    </button>
                                    <span class="text-xs px-3">Page {{ current_page }} of {{ total_pages }}</span>
                                    <button class="btn btn-sm btn-outline-secondary" @click="next_page"
                                        :disabled="current_page === total_pages">
                                        <i class="fas fa-chevron-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="card shadow-md rounded-3 mt-3" v-else>
                    <div class="card-body p-5">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="text-center py-4">
                                <i class="fas fa-info-circle text-info fa-3x mb-3"></i>
                                <p class="text-muted mb-0">No workflow routers found</p>
                                <small class="text-muted d-block mt-2">Click "Add Workflow Router" to get started</small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sub Workflow Detail View -->
                <div class="card shadow-md rounded-3 mt-3" v-if="selected_sub_workflow">
                    <div class="card-body p-4">
                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <div class="d-flex align-items-center">
                                <button class="btn btn-sm btn-transparent me-3" @click="close_sub_workflow_detail">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-project-diagram text-primary fa-xl me-3"></i>
                                    <div>
                                        <span class="fw-bold d-block">{{ selected_sub_workflow.service_name }}</span>
                                        <span class="text-muted fst-italic text-xs">
                                            {{ selected_sub_workflow.sub_workflow_type }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button class="btn btn-bg-green rounded-small text-xs" @click="save_sub_workflow_changes">
                                    <i class="fas fa-save me-1"></i> Save Changes
                                </button>
                            </div>
                        </div>

                        <!-- External Sub Workflow type form -->
                        <div v-if="selected_sub_workflow.sub_workflow_type === 'external'">
                            <div class="row mb-3">
                                <div class="col-md-12">
                                    <div class="card rounded-3 mb-3">
                                        <div class="card-header bg-white">
                                            <h6 class="text-sm pt-2 mb-0">Workflow Router Information</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="mb-3">
                                                <label class="form-label text-xs fw-semibold mb-2">Name of Router</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    v-model="edited_sub_workflow.router_name">
                                            </div>
                                            <div class="mb-3">
                                                <label class="form-label text-xs fw-semibold mb-2">External URL</label>
                                                <input type="url" class="form-control form-control-sm"
                                                    v-model="edited_sub_workflow.external_url">
                                                <small class="text-xxs text-muted d-block mt-2">The URL to the external service</small>
                                            </div>
                                            <div class="mb-0">
                                                <label class="form-label text-xs fw-semibold mb-2">Active Status</label>
                                                <select class="form-select form-select-sm" v-model="edited_sub_workflow.is_active">
                                                    <option value="true">Active</option>
                                                    <option value="false">Inactive</option>
                                                </select>
                                                <small class="text-xxs text-muted d-block mt-2">Set whether this workflow router is currently active</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Internal Sub Workflow type form - choose another workflow -->
                        <div v-else>
                            <div class="row mb-3">
                                <div class="col-md-12">
                                    <div class="card rounded-3 mb-3">
                                        <div class="card-header bg-white">
                                            <h6 class="text-sm pt-2 mb-0">Workflow Router Information</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="mb-3">
                                                <label class="form-label text-xs fw-semibold mb-2">Name of Router</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    v-model="edited_sub_workflow.router_name">
                                            </div>
                                            <div class="mb-3">
                                                <label class="form-label text-xs fw-semibold mb-2">Assign Workflow</label>
                                                <select class="form-select form-select-sm" v-model="edited_sub_workflow.workflow_id">
                                                    <option value="" disabled>Select a workflow</option>
                                                    <option v-for="workflow in available_workflows" :key="workflow.workflow_id" :value="workflow.workflow_id">
                                                        {{ workflow.workflow_name }}
                                                    </option>
                                                </select>
                                                <small class="text-xxs text-muted d-block mt-2">Select the workflow to use as a sub-workflow</small>
                                            </div>
                                            <div class="mb-0">
                                                <label class="form-label text-xs fw-semibold mb-2">Active Status</label>
                                                <select class="form-select form-select-sm" v-model="edited_sub_workflow.is_active">
                                                    <option value="true">Active</option>
                                                    <option value="false">Inactive</option>
                                                </select>
                                                <small class="text-xxs text-muted d-block mt-2">Set whether this workflow router is currently active</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Sub Workflow Modal -->
        <div class="modal fade" id="add_sub_workflow_modal" tabindex="-1" aria-labelledby="add_sub_workflow_modal_Label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="add_sub_workflow_modal_Label"><strong>Add Workflow Router</strong></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body p-4">
                        <form @submit.prevent="add_sub_workflow">
                            <div class="mb-3">
                                <label class="form-label text-xs fw-semibold mb-2">Name of Router <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="new_sub_workflow.service_name" placeholder="Enter router name" required>
                            </div>
                            <div class="mb-3">
                                <label class="form-label text-xs fw-semibold mb-2">Workflow Router Type <span class="text-danger">*</span></label>
                                <select class="form-select" v-model="new_sub_workflow.sub_workflow_type" required>
                                    <option value="internal">Internal Workflow</option>
                                    <option value="external">External Service</option>
                                </select>
                            </div>
                            <div class="mb-3" v-if="new_sub_workflow.sub_workflow_type === 'external'">
                                <label class="form-label text-xs fw-semibold mb-2">External URL <span class="text-danger">*</span></label>
                                <div class="custom-input-wrapper">
                                    <span class="custom-prefilled-text">https://</span>
                                    <input type="text" class="custom-form-control" placeholder="www.example.com" v-model="new_sub_workflow.external_url" @blur="prepend_https" required>
                                </div>
                                <small class="text-xxs text-muted d-block mt-2">The URL to the external service</small>
                            </div>
                            <div class="mb-4" v-if="new_sub_workflow.sub_workflow_type === 'internal'">
                                <label class="form-label text-xs fw-semibold mb-2">Select Workflow <span class="text-danger">*</span></label>
                                <select class="form-select" v-model="new_sub_workflow.workflow_id">
                                    <option value="" disabled selected>Select a workflow</option>
                                    <option v-for="workflow in available_workflows" :key="workflow.workflow_id" :value="workflow.workflow_id">
                                        {{ workflow.workflow_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="d-flex justify-content-end gap-2 mt-4">
                                <button type="button" class="btn btn-bg-dark text-xs rounded-small btn-sm" data-bs-dismiss="modal">Cancel</button>
                                <button type="submit" class="btn btn-bg-green text-xs rounded-small btn-sm">
                                    <i class="fas fa-plus me-1"></i> Add Workflow Router
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>